import get from 'lodash.get';

export class RequestError extends Error {
    constructor(message, error, sourceAssessment) {
        super(message);

        this.status = get(error.response, 'status');
        this.tracekey = get(error.response, 'headers.x-wgen-tracekey');
        this.errorThrown = message;
        this.sourceAssessment = sourceAssessment;
    }
}
